import cfg from '../../config/config.default';

export default class DesignService {
  /**
   * Get latest sold UUIDs
   *
   * @param {string} newerThan
   * @returns {array}
   */
  static async getSoldUuids(newerThan) {
    const response = await fetch(`${ cfg.orderApi.url }sales/?created_at=${ newerThan }`);
    const data = await response.json();
    return data.uuids;
  }

  /**
   * Get details for a list of UUIDs
   *
   * @param {array} uuids
   * @returns {array}
   */
  static async getDesigns(uuids) {
    const response = await fetch(`${ cfg.designApi.url }${ uuids.join(',') }`);
    const data = await response.json();

    // Remove unused attributes
    const designs = data.map((design) => {
      delete design.hash;
      delete design.structure;
      delete design.colors;
      delete design.specs;
      delete design.is_inspiration;
      delete design.is_verified;
      delete design.image_type;
      delete design.camera;
      delete design.last_sold_at;
      delete design.is_deleted;
      delete design.image_url;

      // In case of multiple couchtables
      if (design.dimensions[0]) design.dimensions = design.dimensions[0];

      return design;
    });

    return designs;
  }
}



// WEBPACK FOOTER //
// ./src/services/DesignService/DesignService.js